/**
 * Utility function for generating consistent IDs across editor instances
 */

let counter = 0;

/**
 * Simple hash function to generate short unique IDs
 * Uses timestamp + counter + random for low collision probability
 */
export function simpleHash(): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).slice(2, 6);
  counter += 1;
  return `${timestamp.slice(-4)}${random}${counter}`;
}
